/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioSchema = z.object({
  capacityUtilization: z.enum(['LOW', 'MEDIUM', 'HIGH']),
  color: z.string(),
  colorSecondary: z.string(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  estimationBuffer: z.enum(['LOW', 'MEDIUM', 'HIGH']),
  executionState: z.enum(['SUCCESS', 'IN_PROGRESS', 'FAILED']),
  id: z.int(),
  lastSyncedAt: z.iso.datetime().nullish(),
  loopId: z.int(),
  mlInitiatedAt: z.iso.datetime().nullish(),
  mlReceivedAt: z.iso.datetime().nullish(),
  name: z.string(),
  organizationId: z.string(),
  priorityFlexibility: z.enum(['LOW', 'MEDIUM', 'HIGH']),
  schedulingValidations: z.array(
    z.enum([
      'MISSING_TEAM',
      'EMPTY_TEAM',
      'NO_AVAILABILITY',
      'TEAM_UNAVAILABLE',
      'MISSING_ESTIMATION',
      'ITEM_IS_DONE',
      'ALL_ITEMS_UNSCHEDULABLE',
    ]),
  ),
  status: z.enum([
    'CREATED',
    'RESCHEDULE_QUEUED',
    'ML_INITIATED',
    'ML_VALIDATION_FAILED',
    'ML_VALIDATION_SUCCESS',
    'ML_RECEIVED',
    'TIMEOUT',
  ]),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
});
